import { AppConstants } from '@/helpers/app.constants';
import { PropertyHelper } from '@/helpers/property.helper';
import { AlertService } from '@/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { AttributeGroup, DataDictionaryService, PropertyCategory } from '@eemo/api-client';

import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { InputNullValueDirective } from '../../extensions/inputNullValueDirective';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { NgIf, NgFor } from '@angular/common';
import { InputTrimDirective } from '../../extensions/inputTrimDirective';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

export class AttributeGroupDialogData {
  group: AttributeGroup;
  edition = false;
}

@Component({
    selector: 'app-attribute-group-dialog',
    templateUrl: './attribute-group-dialog.component.html',
    styleUrls: ['./attribute-group-dialog.component.scss'],
    standalone: true,
    imports: [MatDialogModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, InputTrimDirective, NgIf, MatSelectModule, NgFor, MatOptionModule, InputNullValueDirective, MatSlideToggleModule, MatButtonModule]
})
export class AttributeGroupDialogComponent implements OnInit {
  groupForm: UntypedFormGroup;
  dialogTitle: string;
  formSubmitting = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AttributeGroupDialogData,
    private dictService: DataDictionaryService,
    private fb: UntypedFormBuilder,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<AttributeGroupDialogComponent>,
    public propHelper: PropertyHelper
  ) {
    this.dialogTitle = this.data.edition ? 'Modifier le groupe' : 'Créer un nouveau groupe';
  }

  // convenience getter for easy access to form fields
  f(field: string): AbstractControl {
    return this.groupForm.get(field);
  }

  ngOnInit() {
    this.groupForm = this.fb.group({
      code: ['', [Validators.required, Validators.pattern(AppConstants.FORM_PATTERN_CODE)]],
      category: [PropertyCategory.BUILDING, Validators.required],
      display: this.fb.group({
        name: ['', [Validators.required, Validators.maxLength(50)]],
        order: [null, Validators.pattern(AppConstants.FORM_PATTERN_POSITIVE_INTEGER)],
        collapsed: [false]
      })
    });

    if (this.data.group) {
      this.groupForm.patchValue(this.data.group);
    }
  }

  onSubmit() {
    if (this.groupForm.valid) {
      this.formSubmitting = true;
      this.dictService.createDictionaryGroup(this.groupForm.value).subscribe(
        (result) => {
          this.dialogRef.close(true);
          const mess = this.data.edition ? 'Modification du groupe effectuée' : 'Création du groupe effectuée';
          this.alertService.success(mess);
        },
        (err: HttpErrorResponse) => {
          this.dialogRef.close(false);
        }
      );
    }
  }
  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
